import React from 'react';
import Img from 'gatsby-image';
import { VisualImages } from './types';

const FullScreen: React.StatelessComponent<VisualImages> = ({ images }) =>
    images[0].visual_image.localFile &&
    images[0].visual_image.localFile.childImageSharp && (
        <div className="Visual-fullScreen">
            <Img sizes={images[0].visual_image.localFile.childImageSharp.sizes} />
        </div>
    );

export default FullScreen;
